import { useState, useEffect } from 'react';
import { useLocale } from '@adsk/alloy-react-locale';
import { useDataApi } from '@adsk/alloy-helpers';
import {
  useCurrentAccountId,
  useCurrentProjectId,
  useProjectEntitlements,
} from '@adsk/alloy-provider';
import {
  getOfferingsURL,
  getTrialsURLForAA,
  getTrialsURLForPA,
  getProductsSubscriptions,
} from './utils';

const useProductsSubscriptions = (
  member,
  products,
  fetchSubscriptions,
  productIds
) => {
  const [productsSubscriptions, setProductsSubscriptions] = useState({});
  const currentAccountId = useCurrentAccountId();
  const currentProjectId = useCurrentProjectId();
  const { currentProject } = useProjectEntitlements();
  const isAccountAdmin = currentProject?.accessLevels?.accountAdministrator;
  const isProjectAdmin = currentProject?.accessLevels?.projectAdministrator;
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  const { data: memberOfferingsData, doFetch: doGetMemberOfferings } =
    useDataApi();
  const { data: memberTrialsData, doFetch: doGetMemberTrials } = useDataApi();

  useEffect(() => {
    if (!currentAccountId || !fetchSubscriptions) return;

    setProductsSubscriptions({});
    doGetMemberOfferings(getOfferingsURL(currentAccountId, member.id));
  }, [currentAccountId, doGetMemberOfferings, fetchSubscriptions, member.id]);

  useEffect(() => {
    if (
      !currentAccountId ||
      !currentProjectId ||
      !fetchSubscriptions ||
      (!isAccountAdmin && !isProjectAdmin)
    )
      return;

    doGetMemberTrials(
      isAccountAdmin
        ? getTrialsURLForAA(currentAccountId, member.id)
        : getTrialsURLForPA(currentProjectId, member.id)
    );
  }, [
    currentAccountId,
    currentProjectId,
    doGetMemberTrials,
    fetchSubscriptions,
    isAccountAdmin,
    isProjectAdmin,
    member.id,
  ]);

  useEffect(() => {
    if (!memberOfferingsData || !memberTrialsData || !productIds) return;

    setProductsSubscriptions(
      getProductsSubscriptions(
        memberOfferingsData,
        memberTrialsData,
        member,
        products,
        T,
        productIds
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberOfferingsData, memberTrialsData, products, productIds]);

  return productsSubscriptions;
};

export default useProductsSubscriptions;
